/** Canonical (AWS-style) Secret Manager id of an instance's install secret.
 * Other providers rewrite it with their `replacer`. */
export const serviceNowAiInstallSecretId = (instanceId: string): string =>
  `p0/install/servicenow/${instanceId}/install`;

/** Canonical prefix that every session token secret of an instance starts
 * with. Other providers rewrite it with their `replacer`. */
export const serviceNowAiTokenPrefix = (instanceId: string): string =>
  `p0/access-token/servicenow/${instanceId}/`;

/** The connector's Cloud Run service name. Its Lambda function name adds
 * "-aws". */
export const serviceNowAiConnectorName = "p0-connector-servicenow-ai";
